import { gql } from '@apollo/client';

export const SIGNUP_MUTATION = gql`
    mutation CreateUser($email: String!, $nickname: String!, $gender: String!, $name: String!, $mobile_number: String, $password_hash: String!, $birthday: date!, $graduates_in: Int!) {
    insert_users(objects: {birthday: $birthday, email: $email, gender: $gender, graduates_in: $graduates_in, mobile_number: $mobile_number, name: $name, nickname: $nickname, password_hash: $password_hash}) {
      returning {
        id
      }
    }
  }`;

export const LOGIN_MUTATION = gql`
    mutation userLogin($email: String!, $password_hash: String!) {
        update_users(where: {email: {eq: $email}, and: {password_hash: {_eq: $password_hash}}}) {
            returning {
                id
                auth_key
            }
        }
    }
`;

export const LOGOUT_MUTATION = gql`
    mutation Logout {
        logout
    }
`;
export const RESET_PASSWORD_MUTATION = gql`
    mutation updatePassword($id: uuid!, $password: String!) {
        update_users(where: {id: {_eq: $id}}, _set: {password_hash: $password}) {
        affected_rows
        }
    }
`;

export const SET_AUTH_KEY = gql`
    mutation SetUserAuthKey($id: uuid!, $auth_key: String!) {
        update_users_by_pk(pk_columns: {id: $id}, _set: {auth_key: $auth_key}) {
            id
            auth_key
        }
  }
`;
export const ACTIVATE_USER = gql`
    mutation activateUser($id: uuid!) {
        update_users(where: {id: {_eq: $id}}, _set: {status: "active"}) {
            returning {
                id
                status
            }
        }
    }
`;
export const ACTIVATE_VOUCHER    = gql`
    mutation activateVoucher($code: String!, $user: uuid!, $date: timestamptz!) {
        update_wallet_voucher(where: {code: {_eq: $code}}, _set: {assigned_user: $user, activation_date: $date}) {
            returning {
                code
                assigned_user
                value
            }
        }
    }
`;
export const UPDATE_USER_MUTATION = gql`
    mutation updateUserById($id: uuid!, $email: String, $graduates_in: Int, $mobile_number: String, $name: String) {
            update_users_by_pk(pk_columns: {id: $id}, _set: {email: $email, graduates_in: $graduates_in, mobile_number: $mobile_number, name: $name}) {
            id
            graduates_in
            email
            gender
            birthday
            mobile_number
            name
            nickname
        }
    }
`;

